/**
 * Breakpoint helper utilities
 * Mirrors the logic from Java Breakpoint.java enum
 */

/**
 * Get the number of columns for article list page based on breakpoint
 * This matches the logic in Breakpoint.java getNumberOfColumnsForArticleListPage()
 *
 * @param {string} breakpoint - Current breakpoint (s, m, l, xl, xxl, xxxl)
 * @returns {number} Number of columns for article list page
 */
export function getColumnsForBreakpoint(breakpoint) {
    const bp = breakpoint.toLowerCase();
    switch (bp) {
        case 's':
            return 2;
        case 'm':
            return 3;
        case 'l':
        case 'xl':
        case 'xxl':
        case 'xxxl':
            return 4;
        default:
            return 4;
    }
}
